// Location: src/styles/cardStyles.js
// Date: 20240929
// Author: R Matthews
// Purpose: Styles for card components

import { makeStyles, tokens } from '@fluentui/react-components';

const cardBaseStyles = {
  width: '100%',
  height: 'fit-content',
  padding: tokens.spacingM,
  borderRadius: tokens.borderRadiusMedium,
  boxShadow: tokens.shadow4,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: tokens.spacingS,
};

export const useCardStyles = makeStyles({
  card: {
    ...cardBaseStyles,
    maxWidth: '400px',
    flex: '1 1 400px',
  },
  cardHeader: {
    minHeight: '250px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  cardBody: {
    minHeight: '20px',
  },
  cardPreviewImage: {
    width: '100%',
    height: '200px',
    objectFit: 'Fit',
    objectPosition: '50% 21%',
  },
  cardFooter: {
    minHeight: '20px',
  },
  heroCard: {
    ...cardBaseStyles,
  },
  sectionCard: {
    ...cardBaseStyles,
    backgroundColor: tokens.colorNeutralBackground4,
  },
  stripeCard: {
    ...cardBaseStyles,
    width: '300px',
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    zIndex: 1000,
  },
  testimonialCard: {
    ...cardBaseStyles,
    maxWidth: '300px',
    flex: '1 1 300px',
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground2,
  },
  partnerCard: {
    ...cardBaseStyles,
    flex: '1 1 auto',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  footerCard: {
    ...cardBaseStyles,
    flex: '1 1 30%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media (max-width: 768px)': {
      flex: '1 1 100%',
    },
    '@media (min-width: 769px) and (max-width: 1024px)': {
      flex: '1 1 45%',
    },
    '@media (orientation: landscape) and (max-width: 768px)': {
      flex: '1 1 45%',
    },
  },
});